import { QrCode } from 'lucide-react';
import { TemplateMeta } from './TemplateParts';

export default function RsvpClair({ data }) {
  const {
    coupleName,
    rows,
    shortPhrase,
    ctaText,
    showSiteLink,
    siteUrl,
    showQrCode,
    textColor,
    textShadow,
    accentColor,
    titleStyle,
    bodyStyle,
    isPremium
  } = data;

  return (
    <div className="absolute inset-0 p-5 md:p-6 flex flex-col">
      <div className="mt-auto w-full max-w-[90%] rounded-[26px] border border-white/70 bg-white/90 shadow-[0_20px_34px_rgba(37,25,20,0.24)] p-5 md:p-6">
        <div className="flex items-center justify-between">
          <p className="text-[10px] uppercase tracking-[0.16em] font-semibold text-[#7A5E4A]">Confirmação de presença</p>
          {isPremium ? (
            <span className="rounded-full px-2 py-1 text-[10px] uppercase tracking-[0.12em] font-semibold bg-[#FFF4E5] text-[#9C784C]">Premium</span>
          ) : null}
        </div>

        <div className="mt-3 grid grid-cols-[1.3fr_0.7fr] gap-4">
          <div>
            <h4 className="text-[2rem] md:text-[2.6rem] font-bold leading-[1.05]" style={titleStyle}>{coupleName}</h4>
            <div className="mt-3">
              <TemplateMeta rows={rows} textColor={textColor} textShadow={textShadow} family={bodyStyle.metaFamily} tracking={bodyStyle.metaTracking} />
            </div>
            {shortPhrase ? <p className="mt-3 text-sm" style={bodyStyle.style}>{shortPhrase}</p> : null}
            <div className="mt-4 rounded-lg px-3 py-2 text-xs uppercase tracking-[0.14em] font-semibold" style={{ backgroundColor: `${accentColor || '#C8A97E'}33`, color: '#5E4736' }}>
              {ctaText || 'Responder presença'}
            </div>
          </div>

          <div className="flex flex-col justify-between">
            {showQrCode ? (
              <div className="rounded-xl p-2 border border-[#EADCD8] bg-white flex items-center justify-center">
                <QrCode className="w-14 h-14 text-[#1C1C1C]" />
              </div>
            ) : <div />}
            {showSiteLink ? (
              <div className="rounded-lg border border-[#EADCD8] bg-[#FFF9F4] px-2 py-2">
                <p className="text-[10px] uppercase tracking-[0.12em] font-semibold" style={{ color: accentColor || '#9A6B65' }}>RSVP no site</p>
                <p className="text-[11px] truncate text-[#1C1C1C]">{siteUrl || 'vireinoiva.com.br'}</p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
